import React from "react";
import { ErrorMessage, Field } from "formik";
import { Editor } from "primereact/editor";

function EditorComponent(props: any) {
  const { name, label, extendedlabel, isRequired, ...rest } = props;
  return (
    <div className="flex flex-col w-full py-2" id={name.split(".").pop()}>
      <label htmlFor={name} className={isRequired ? "isRequired" : ""}>
        {" "}
        {label}
      </label>
      {extendedlabel && (
        <div className="helpertext">
          <i>{extendedlabel}</i>
        </div>
      )}{" "}
      <Field alt={name} name={name} {...rest} as={Editor} />
      <ErrorMessage name={name} render={(msg) => <div className="error">{msg}</div>} />
    </div>
  );
}
export default EditorComponent;
